module.exports = __webpack_public_path__ + "static/img/login_uav.a58c2c82.png";